// Theme names taken from primary color names
export enum InputTheme {
  Default = 'default',
  Error = 'error',
  Lemon = 'lemon',
  Success = 'success',
  Tempus = 'primary',
  Warning = 'warning',
  Dark = 'dark',
  Transparent = 'transparent',
}
